import { FC } from 'react';
import { DeletePass } from '@doda/io-react/common';
import { deleteCookie } from '@doda/common/src/utils/cookieUtil';
import { useRouter } from 'next/router';
import {
  USER_CLICK_SEARCHCONDITION,
  generateUrl,
} from 'components/FollowSearchResultsNavigation/logics/generateUrl';
import styles from './index.module.scss';
import { SearchedConditionsProps } from '../SearchedConditions';

/**
 * 最近検索した条件 コンテンツ
 * @param searchConditionList 検索条件ラベル取得APIレスポンスのリスト
 * @param setSearchConditionList セッタ関数（検索条件ラベル取得APIレスポンスのリスト）
 * @param dateList 検索履歴保存日のリスト
 * @param setDateList セッタ関数（検索履歴保存日のリスト）
 * @param onClickShowConfirm 一括削除確認の表示用クリックイベント
 */
interface Props {
  searchConditionList: SearchedConditionsProps['searchConditionList'];
  updateSearchConditionList: SearchedConditionsProps['updateSearchConditionList'];
  onClickShowConfirm: () => void;
  loginStatus: SearchedConditionsProps['loginStatus'];
}

export const SearchedConditionsContents: FC<Props> = ({
  searchConditionList,
  updateSearchConditionList,
  onClickShowConfirm,
  loginStatus,
}) => {
  const router = useRouter();

  // 押下された検索履歴のみ削除
  const onClickDeleteSearchCondition = (id: number) => {
    const targetCookie = `search_condition${id}`;
    deleteCookie(targetCookie);
    const newSearchConditionList = searchConditionList.filter(
      (item) => item.id !== id
    );
    updateSearchConditionList(newSearchConditionList);
  };

  // 求人一覧画面URLの生成
  const createJobSearchListUrl = (transitionUrl: string | undefined) => {
    if (!transitionUrl) return '';

    const url = generateUrl({
      baseUrl: transitionUrl,
      userClickList: USER_CLICK_SEARCHCONDITION,
      pathname: router.pathname,
      loginStatus,
    });
    return url;
  };

  return (
    <div className={styles.searchedConditionsContentsWrapper}>
      <ul className={styles.searchedConditionsContentsWrapper__lists}>
        {searchConditionList.map(({ id, labelData, saveDate }) => (
          <li
            key={id}
            className={styles.searchedConditionsContentsWrapper__listItem}
          >
            <a href={createJobSearchListUrl(labelData.transitionUrl)}>
              <p className={styles.searchedConditionsContentsWrapper__date}>
                {saveDate}
              </p>
              <p
                className={
                  styles.searchedConditionsContentsWrapper__conditionName
                }
              >
                {labelData.summary === '' ? '指定なし' : labelData.summary}
              </p>
            </a>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onClickDeleteSearchCondition(id);
              }}
              className={styles.searchedConditionsContentsWrapper__deleteBtn}
            >
              <DeletePass size="M" />
            </button>
          </li>
        ))}
      </ul>
      <div className={styles.searchedConditionsContentsWrapper__btmArea}>
        <button
          type="button"
          className={styles.contentsWrapper__allDeleteBtn}
          onClick={(e) => {
            e.stopPropagation();
            onClickShowConfirm();
          }}
        >
          一括削除
        </button>
      </div>
    </div>
  );
};
